module.exports = __webpack_public_path__ + "media/components/country-flag/static/bz-a868e292e742687bc505aae926cae7e0.svg";